
/**
 * Export `isProduction`.
 */

export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production'; // eslint-disable-line no-process-env
}

/**
 * Export `isProductionEnvironment`.
 */

export function isProductionEnvironment(): boolean {
  return process.env.NODE_CONFIG_ENV === 'prd'; // eslint-disable-line no-process-env
}
